import * as React from 'react';

import { OfferGallery } from './components/OfferGallery';
import { TMessage, TOutcomingStatus } from '../../types/messages';

type TOfferGalleryContainerProps = {
  messageId: string;
  message: TMessage & { status: TOutcomingStatus };
};

export const ChatMessageOfferGalleryContainer = React.forwardRef<HTMLDivElement, TOfferGalleryContainerProps>(
  function ChatMessageOfferGalleryContainer({ messageId, message }, ref: React.RefObject<HTMLDivElement>) {
    const { offers, isRead, animation } = message;

    const [scrollStyles, setScrollStyles] = React.useState({
      hideLeft: true,
      hideRight: false,
    });

    React.useEffect(() => {
      const gallery = ref?.current;

      if (!gallery) {
        return;
      }

      const updateArrows = () => {
        setScrollStyles({
          hideLeft: gallery.scrollLeft === 0,
          hideRight: Math.ceil(gallery.scrollLeft + gallery.clientWidth) >= gallery.scrollWidth,
        });
      };

      updateArrows();

      gallery.addEventListener('scroll', updateArrows);

      return () => {
        gallery.removeEventListener('scroll', updateArrows);
      };
    }, []);

    const scrollGallery = (direction: 'left' | 'right') => {
      if (ref.current) {
        const scrollAmount = 300; // Количество пикселей для прокрутки

        ref.current.scrollBy({
          left: direction === 'left' ? -scrollAmount : scrollAmount,
          behavior: 'smooth',
        });
      }
    };

    return (
      <OfferGallery
        offers={offers}
        isRead={isRead}
        animation={animation}
        messageId={messageId}
        message={message}
        scrollStyles={scrollStyles}
        onScrollLeft={() => scrollGallery('left')}
        onScrollRight={() => scrollGallery('right')}
        ref={ref}
      />
    );
  },
);
